window.showModal = function (title) {
  $('.modal-body').html(setSpinner())
  $('.modal-title').text(title)
  modal.show()
}

window.hideModal = function () {
  if ($('#modal').attr('on_close_cable') != undefined){
    if ($('#modal').attr('on_close_cable') == 'synchronizationLogChannel'){ unsubscribeSynchronizationLogChannel() }
    $('#modal').removeAttr('on_close_cable')
  }
  modal.hide()

  if (typeof(counterScanHandler) !== 'undefined') {
    document.removeEventListener("keydown", counterScanHandler);
  }

  if (typeof(counterRegularScanHandler) !== 'undefined') {
    document.removeEventListener("keydown", counterRegularScanHandler);
  }

  if (typeof(combineLabelScanHandler) !== 'undefined') {
    document.removeEventListener("keydown", combineLabelScanHandler);
  }
}

window.loadModal = function (params) {
  const title = params.title
  const url   = params.url
  
  showModal(title)

  // penyebab utama scan duplikat n kali, tergantung dari n spasi (" ") yang diketik/discan
  // ini wajib ada:
  $(":focus").blur();
  // soalnya pas klik modal, state 'focus' terakhir masih ada di button trigger
  // user pencet spasi / hasil qr ada spasi (" ") = trigger function ini lagi

  $.ajax({
    url: url,
    dataType: 'script',
    success: function(res){
      $('.modal-body').html(res)
    }, 
    error: function(jqXHR){
      if (jqXHR.status == 403) {
        const json = JSON.parse(jqXHR.responseText)
        $(".modal-body").html(`
          <p class='bg-danger text-center text-white fw-bold text-sm rounded'>${json.message}</p>
        `)
      } else {
        alert("Something error!")
        console.log(jqXHR)
      }
    }
  })
}